// Auto-generated — do not edit
import { i18nBundle } from '@amzn/amp-i18n'
import type { OtaGetString, OtaGetStringAsync } from './types.generated'

const otaLocales = ['en-US'] as const
const otaBundle = i18nBundle('ota/ota', otaLocales)

export const getString: OtaGetString = otaBundle.getString
export const getStringAsync: OtaGetStringAsync = otaBundle.getStringAsync
